export const BaseUrlGeneral = process.env.REACT_APP_BACKEND_URL;
export const BaseUrlAuth = process.env.REACT_APP_BACKEND_URL;

export const getToken = (): string | null => {
  const token = localStorage.getItem('jwt_token')
    ? 'Bearer ' + localStorage.getItem('jwt_token')
    : null;
  return token;
};
